import classNames from "classnames";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

export interface PageBreadcrumbItem {
  label: string;
  url?: string;
  active?: boolean;
}

interface PageBreadcrumbProps {
  items: PageBreadcrumbItem[];
  className?: string;
}

const PageBreadcrumb = ({ items, className }: PageBreadcrumbProps) => {
  return (
    <Breadcrumb className={classNames(className, "mb-2")}>
      {items.map((item) => {
        // For active items or items without URL, render as plain breadcrumb item
        if (item.active || !item.url) {
          return (
            <Breadcrumb.Item
              active={item.active}
              key={item.label}
            >
              {item.label}
            </Breadcrumb.Item>
          );
        }
        
        // For non-active items with URL, render as plain breadcrumb item with Link wrapper
        return (
          <Breadcrumb.Item key={item.label}>
            <Link to={item.url} className="text-decoration-none">
              {item.label}
            </Link>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default PageBreadcrumb;
